/* eslint-disable global-require */
/**
 * Module dependencies
 */
const getChatStatus = (ref) => localStorage.getItem(ref);

const setChatStatus = (ref, refer) => {
  localStorage.setItem(ref, refer);
  const storageEvent = new StorageEvent('storage', {
    key: ref,
    newValue: refer,
  });
  window.dispatchEvent(storageEvent);
};

const removeChatStatus = (ref) => {
  localStorage.removeItem(ref);
};

module.exports = {
  getChatStatus,
  setChatStatus,
  removeChatStatus,
};
